export const qs = (s, el = document) => el.querySelector(s)
export const qsa = (s, el = document) =>
  Array.prototype.slice.call(el.querySelectorAll(s))
